'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _styledComponents = require('styled-components');

var breakpoints = {
  hd: 1920,
  sd: 1366,
  cs: 1190,
  tablet: 1024,
  tabletPortrait: 800,
  phoneLarge: 680,
  phone: 500
};

exports.default = Object.keys(breakpoints).reduce(function (acc, label) {
  acc[label] = function () {
    return (0, _styledComponents.css)(['@media (max-width:', 'em){', '}'], breakpoints[label] / 16, _styledComponents.css.apply(undefined, arguments));
  };
  return acc;
}, {});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/utils/responsiveBreakpoints.js
// module id = 12
// module chunks = 3 4